<template>
  <v-layout :class="['layout', {'layout--dark': dark}]">

    <v-img
        v-if="dark" cover class="layout__background"
        src="https://images.unsplash.com/photo-1583587635709-9c11b65fc1af?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80"
    />

    <div class="layout__grid pa-0 my-0">

     <v-container>
       <Header v-bind="header" :multi-page="multiPage" :multi-lang="multiLang" />

       <HeaderImage
           v-if="header.image"
           :image="header.image"
           class="mt-6 pb-16"
       />
     </v-container>

      <slot />

      <v-container>
        <Footer class="mt-16 pt-16" />
      </v-container>

    </div>

  </v-layout>
</template>

<script setup lang="ts">
defineProps<{
  dark?: boolean,
  header: IHeader,

  multiPage?: boolean,
  multiLang?: boolean,
}>()

const drawerPlace: Ref<boolean> = ref(false)
</script>

<style scoped lang="scss">
.layout {
  position: relative;
  color: black;

  i {
    color: black;
  }

  &--dark {
    color: white;

    i {
      color: white;
    }

    :deep(.footer__location) .v-row {
      border-bottom: 1px dotted lightgrey;

      .v-col span {
        background: #2b2a2a !important;
      }
    }
  }

  &__background {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #282828;

    :deep(img) {
      opacity: 0.1;
    }
  }

  &__grid {
    position: relative;
    width: 100%;
    z-index: 1;
  }
}
</style>
